import * as ACTIONS from "@iso/redux/tags/actionTypes";

const initialState = {
  tags: {
    list: [],
    total: 0,
  },
};

function tagsReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case ACTIONS.GET_TAGS_SUCCESS: {
      return {
        ...state,
        ...{ tags: payload },
      };
    }

    default:
      return state;
  }
}

export default tagsReducer;
